module.exports = __webpack_public_path__ + "static/media/resultunimarc.ea137bc9.png";